import { authFetch } from './utils/authFetch';
import { useAuthContext } from './context/AuthProvider';
import * as Sentry from '@sentry/browser';

class AuthAPI {
  async recordUserLogin(email) {
    // ZAPT recordLogin removed — analytics already tracks sign-in in AuthProvider.
    console.log('Login established for user:', email);
  }

  async checkStripeCustomer() {
    try {
      const response = await authFetch('/api/check-stripe-customer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return {
        hasCustomer: result.exists || false,
        customerId: result.customerId || null,
        customer: result.customer || null,
      };
    } catch (error) {
      console.error('Error checking Stripe customer:', error);
      Sentry.captureException(error, { extra: { context: 'checkStripeCustomer' } });
      return { hasCustomer: false, customerId: null, customer: null };
    }
  }
}

export const authApi = new AuthAPI();

/**
 * Attach Authorization header from current Stytch session JWT.
 */
export function useSessionAuthHeaders() {
  const { session } = useAuthContext();
  return {
    Authorization: session?.access_token ? `Bearer ${session.access_token}` : undefined,
    'Content-Type': 'application/json',
  };
}
